export default {
  list: [],
  leadFromGridData: [],
  leadForGridData: [],
};
